<template>
  <section class="about-section">
    <div class="container">
      <div class="section-header">
        <h2 class="section-title">关于我们</h2>
        <p class="section-subtitle">专业、创新、值得信赖的科技合作伙伴</p>
      </div>

      <div class="about-content">
        <div class="about-text">
          <div class="company-intro">
            <h3>{{ companyInfo ? companyInfo.companyName : '上海倾至城科技有限公司' }}</h3>
            <p v-if="companyInfo">{{ companyInfo.description }}</p>
            <p v-else>
              上海倾至城科技有限公司是一家专注于科技创新和数字化转型的高新技术企业。
              我们致力于为客户提供优质的技术解决方案，推动行业创新发展。
            </p>
          </div>

          <div class="company-values">
            <div class="value-item" v-for="(value, index) in coreValues" :key="index">
              <div class="value-icon">
                <i :class="value.icon"></i>
              </div>
              <div class="value-content">
                <h4>{{ value.title }}</h4>
                <p>{{ value.description }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="about-stats">
          <div class="stat-item">
            <div class="stat-number">{{ companyInfo ? companyInfo.foundedYear : '2020' }}</div>
            <div class="stat-label">成立年份</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">{{ companyInfo ? companyInfo.employeeCount : '50' }}+</div>
            <div class="stat-label">专业团队</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">100+</div>
            <div class="stat-label">成功项目</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">99%</div>
            <div class="stat-label">客户满意度</div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'AboutSection',
  data () {
    return {
      coreValues: [
        {
          icon: 'el-icon-lightbulb',
          title: '创新',
          description: '持续创新，追求卓越，为客户创造更大价值'
        },
        {
          icon: 'el-icon-medal',
          title: '专业',
          description: '专业的技术团队，提供高质量的技术服务'
        },
        {
          icon: 'el-icon-user',
          title: '诚信',
          description: '诚信为本，建立长期稳定的合作关系'
        },
        {
          icon: 'el-icon-connection',
          title: '合作',
          description: '开放合作，与客户共同成长发展'
        }
      ]
    }
  },
  computed: {
    ...mapState(['companyInfo'])
  }
}
</script>

<style lang="scss" scoped>
.about-section {
  padding: 80px 0;
  background: white;
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: $text-primary;
  margin-bottom: 16px;
}

.section-subtitle {
  font-size: 1.1rem;
  color: $text-secondary;
  max-width: 600px;
  margin: 0 auto;
}

.about-content {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 60px;
  align-items: start;
}

.company-intro {
  margin-bottom: 40px;

  h3 {
    font-size: 1.5rem;
    color: $primary-color;
    margin-bottom: 16px;
  }

  p {
    font-size: 1rem;
    line-height: 1.8;
    color: $text-regular;
    margin-bottom: 16px;
  }
}

.company-values {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}

.value-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;

  .value-icon {
    width: 48px;
    height: 48px;
    background: linear-gradient(135deg, $primary-color, lighten($primary-color, 20%));
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    i {
      font-size: 20px;
      color: white;
    }
  }

  .value-content {
    h4 {
      font-size: 1.1rem;
      font-weight: 600;
      color: $text-primary;
      margin-bottom: 8px;
    }

    p {
      font-size: 0.9rem;
      color: $text-secondary;
      line-height: 1.6;
    }
  }
}

.about-stats {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}

.stat-item {
  text-align: center;
  padding: 24px;
  background: linear-gradient(135deg, #f8f9ff, #e8f0ff);
  border-radius: $border-radius-large;
  border: 1px solid $border-light;

  .stat-number {
    font-size: 2.5rem;
    font-weight: 700;
    color: $primary-color;
    margin-bottom: 8px;
  }

  .stat-label {
    font-size: 0.9rem;
    color: $text-secondary;
    font-weight: 500;
  }
}

// 响应式设计
@media (max-width: 768px) {
  .about-section {
    padding: 60px 0;
  }

  .section-title {
    font-size: 2rem;
  }

  .about-content {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .company-values {
    grid-template-columns: 1fr;
  }

  .about-stats {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  .about-stats {
    grid-template-columns: 1fr;
  }
}
</style>
